/**
 * Transform booking parts into a list of ticket download groups.
 *
 * Tickets are grouped per activity, accommodation or all P2P trips together
 */
export function transformTicketGroups(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']): TicketGroup[] {
    return [
        ...transformTicketGroupsActivity(bookingParts, response),
        ...transformTicketGroupsAccommodation(bookingParts, response),
        ...transformTicketGroupsP2P(bookingParts, response),
    ];
}
